import authServices from '../api/authServices';
import Cookies from 'js-cookie';
import { NavigateFunction } from 'react-router-dom';

const localStorageKeys = ['lastActive', 'accountNumber'];

const signInScope = async (username: string, password: string) => {
  let signInData = {};

  await authServices.logIn(username, password).then((resp: any) => {
    signInData = resp;
    setToken(resp);
  });
  return signInData;
};

const setToken = (resp: any) => {
  if (resp.phoneValidated && !resp.mfaEnabled) return Cookies.set('accessToken', resp.accessToken, { expires: 1 / 24, path: '/' });

  Cookies.set('tmpToken', resp.accessToken, { expires: 1 });
};

const signOutScope = async () => {
  await authServices.logOut().then(_resp => {
    Cookies.remove('accessToken');
    localStorageKeys.forEach(item => localStorage.removeItem(item));
  });
};

const redirectToLogin = (navigate: NavigateFunction) => {
  Cookies.remove('accessToken');
  Cookies.remove('tmpToken');
  navigate('/log-in');
};

export { signInScope, signOutScope, redirectToLogin };
